(function () {
  function initializeFilters(root) {
    if (!root || root.dataset.ccReady === "true") return;
    root.dataset.ccReady = "true";
    var buttons = root.querySelectorAll("[data-cc-filter]");
    var products = root.querySelectorAll("[data-cc-product]");
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var selected = button.dataset.ccFilter;
        buttons.forEach(function (item) { item.classList.toggle("is-active", item === button); });
        products.forEach(function (product) {
          product.hidden = selected !== "all" && product.dataset.category !== selected;
        });
      });
    });
  }

  function initializeFulfillment(root) {
    if (!root || root.dataset.ccReady === "true") return;
    root.dataset.ccReady = "true";
    var method = root.querySelector("[data-cc-fulfillment-method]");
    var date = root.querySelector("[data-cc-fulfillment-date]");
    var time = root.querySelector("[data-cc-fulfillment-time]");
    var address = root.querySelector("[data-cc-delivery-address]");
    var addressInput = address && address.querySelector("input");
    if (date) {
      var now = new Date();
      var localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      date.min = localDate;
    }
    function updateMethod() {
      var delivery = method && method.value.indexOf("Delivery") !== -1;
      if (address) address.hidden = !delivery;
      if (addressInput) addressInput.required = delivery;
    }
    function updateHours() {
      if (!date || !time || !date.value) return;
      var weekday = new Date(date.value + "T12:00:00").getDay();
      time.min = weekday === 0 ? "12:00" : "10:00";
      time.max = weekday === 0 ? "18:00" : "20:00";
      if (time.value && (time.value < time.min || time.value > time.max)) time.value = "";
    }
    if (method) method.addEventListener("change", updateMethod);
    if (date) date.addEventListener("change", updateHours);
    updateMethod();
    updateHours();
  }

  function initialize() {
    document.querySelectorAll("[data-cc-anniversary]").forEach(initializeFilters);
    document.querySelectorAll("[data-cc-fulfillment-fields]").forEach(initializeFulfillment);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize);
  else initialize();
  document.addEventListener("shopify:section:load", initialize);
})();
